"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Bookingkit Api v4
 * Specification of Bookingkit Api v4
 *
 * The version of the OpenAPI document: 0.25.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleResponseIdEnum = void 0;
exports.ModuleResponseIdEnum = {
    AdditionalField: 'additional_field',
    AdvertisedPrice: 'advertised_price',
    ContentLocal: 'content_local',
    Contingents: 'contingents',
    CrossSelling: 'cross_selling',
    Developer: 'developer',
    DiffMktContent: 'diff_mkt_content',
    EInvoice: 'e-invoice',
    Email: 'email',
    EmailCampaign: 'email_campaign',
    EventAttachment: 'event_attachment',
    ExtendedPrice: 'extended_price',
    Flexibleduration: 'flexibleduration',
    FlexiblePricing: 'flexible_pricing',
    FlexTicket: 'flex_ticket',
    FreeParticipant: 'free_participant',
    InvoiceCorrect: 'invoice_correct',
    MinParticipants: 'min_participants',
    NewsletterOpt: 'newsletter_opt',
    OpeningHours: 'opening_hours',
    ProductBundles: 'product_bundles',
    PromoteLocal: 'promote_local',
    ResourceMgmt: 'resource_mgmt',
    Tickets: 'tickets',
    _3rdPartyReview: '3rd_party_review',
    UserManagement: 'user_management',
    SumUp: 'SumUp',
    Yield: 'yield'
};
